import {Component, OnInit} from '@angular/core';
import {ConfService} from '../../conf.service';
import {MatDialog, MatIconRegistry, MatSnackBar} from '@angular/material';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';

@Component({
    selector: 'app-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {
    isChecked = false;
    isLoading = false;
    panelOpenState = false;
    panelOpenState1 = false;
    panelOpenState2 = false;
    crtFileName = '';
    keyFileName = '';
    pfxFileName = '';
    pemFileName = '';
    crtFilePath = '';
    keyFilePath = '';
    pfxFilePath = '';
    pemFilePath = '';
    isDisabled = true;
    selectedFile = File;
    fileName = '';
    tokenURL = '';
    client_id = '';
    client_secret = '';
    grant_type = '';
    access_token = '';
    token_type = '';
    scope = '';
    expires_in = '';
    host = '';
    port = '';

    constructor(private confPost: ConfService, public snackBar: MatSnackBar, public platform: LeftpanelComponent, public dialog: MatDialog) {
    }

    ngOnInit() {
        // this.getSSLFiles();
    }

    uploadCRT(event) {
        this.fileName = 'CRT';
        this.selectFile(event, this.fileName);
        this.isDisabled = false;
        event.target.value = '';
    }

    uploadKEY(event1) {
        this.fileName = 'KEY';
        this.selectFile(event1, this.fileName);
        this.isDisabled = false;
        event1.target.value = '';
    }

    uploadPFX(event2) {
        this.fileName = 'PFX';
        this.selectFile(event2, this.fileName);
        this.isDisabled = false;
        event2.target.value = '';
    }

    uploadPEM(event3) {
        this.fileName = 'PEM';
        this.selectFile(event3, this.fileName);
        this.isDisabled = false;
        event3.target.value = '';
    }

    selectFile(event, fileName) {
        this.selectedFile = event.target.files[0];
        this.uploadFile(this.selectedFile, fileName);
    }

    getSSLFiles() {
        if (this.isChecked) {
            this.confPost.getSSLFilesPath(localStorage.getItem('account'), localStorage.getItem('partner')).subscribe(res => {
                if (res['crt_file_name'] !== '') {
                    this.crtFileName = res['crt_file_name'];
                }
                if (res['key_file_name'] !== '') {
                    this.keyFileName = res['key_file_name'];
                }
                if (res['pfx_file_name'] !== '') {
                    this.pfxFileName = res['pfx_file_name'];
                }
                if (res['pem_file_name'] !== '') {
                    this.pemFileName = res['pem_file_name'];
                }
                if (res['crt_file_path'] !== '') {
                    this.crtFilePath = res['crt_file_path'];
                }
                if (res['key_file_path'] !== '') {
                    this.keyFilePath = res['key_file_path'];
                }
                if (res['pfx_file_path'] !== '') {
                    this.pfxFilePath = res['pfx_file_path'];
                }
                if (res['pem_file_path'] !== '') {
                    this.pemFilePath = res['pem_file_path'];
                }
            });
        }
    }

    uploadFile(file, fileName) {
        this.isLoading = true;
        this.confPost.uploadSSLFile(localStorage.getItem('account'), localStorage.getItem('partner'), fileName, file).subscribe(res => {
            if (fileName === 'CRT') {
                this.crtFileName = res['file_name'];
                this.crtFilePath = res['path'];
            } else if (fileName === 'KEY') {
                this.keyFileName = res['file_name'];
                this.keyFilePath = res['path'];
            } else if (fileName === 'PFX') {
                this.pfxFileName = res['file_name'];
                this.pfxFilePath = res['path'];
            } else if (fileName === 'PEM') {
                this.pemFileName = res['file_name'];
                this.pemFilePath = res['path'];
            }
            this.isLoading = false;
        });
    }

    removeFile(fileType) {
        let file_name = '';
        let file_path = '';
        if (fileType === 'CRT') {
            file_name = this.crtFileName;
            file_path = this.crtFilePath;
        } else if (fileType === 'KEY') {
            file_name = this.keyFileName;
            file_path = this.keyFilePath;
        } else if (fileType === 'PFX') {
            file_name = this.pfxFileName;
            file_path = this.pfxFilePath;
        } else if (fileType === 'PEM') {
            file_name = this.pemFileName;
            file_path = this.pemFilePath;
        }
        this.confPost.removeSSLFile(localStorage.getItem('account'), localStorage.getItem('partner'), file_name, file_path).subscribe(res => {
            if (res['message'] === 'file removed') {
                if (fileType === 'CRT') {
                    this.crtFileName = '';
                    this.crtFilePath = '';
                } else if (fileType === 'KEY') {
                    this.keyFileName = '';
                    this.keyFilePath = '';
                } else if (fileType === 'PFX') {
                    this.pfxFileName = '';
                    this.pfxFilePath = '';
                } else if (fileType === 'PEM') {
                    this.pemFileName = '';
                    this.pemFilePath = '';
                }
            }

        });
    }

    configureSSL() {
        if (this.tokenURL !== '') {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                width: 'auto',
                height: 'auto',
            });
            const payload = {
                'token_url': this.tokenURL,
                'crtFilePath': this.crtFilePath,
                'keyFilePath': this.keyFilePath,
                'pfxFilePath': this.pfxFilePath,
                'pemFilePath': this.pemFilePath,
                'client_id': this.client_id,
                'client_secret': this.client_secret,
                'grant_type': this.grant_type
            };
            this.confPost.ConfigureSSL(payload).subscribe(res => {
                this.access_token = res['access_token'];
                this.token_type = res['token_type'];
                this.scope = res['scope'];
                this.expires_in = res['expires_in'];
                loaderDialog.close();
            });
        } else {
            this.platform.openSnackBar('Please enter the token URL', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    removeFiles() {
        this.isDisabled = true;
        this.crtFileName = '';
        this.keyFileName = '';
        this.pfxFileName = '';
        this.pemFileName = '';
    }

}
